import React, { useCallback, useEffect } from "react";

import { useAppUpdateDetector } from "../hooks/useAppUpdateDetector";
import { useAppUpdateStore } from "../updateStore";
import { ForceReloadModal } from "./ForceReloadModal";
import { UpdateBanner } from "./UpdateBanner";

type Props = {
  pollIntervalMs?: number;
};

/**
 * A new build is offered, not imposed: a banner that the next page change
 * acts on. Only a build the running one can't coexist with blocks the page.
 */
export const AppUpdateGate: React.FC<Props> = ({ pollIntervalMs }) => {
  const { update } = useAppUpdateDetector({ pollIntervalMs });
  const setUpdate = useAppUpdateStore((s) => s.setUpdate);
  const dismissed = useAppUpdateStore((s) => s.dismissed);
  const dismiss = useAppUpdateStore((s) => s.dismiss);

  useEffect(() => setUpdate(update), [setUpdate, update]);

  const onReload = useCallback(() => {
    // Reload the current route (SPA routes are supported via Vercel rewrites).
    window.location.reload();
  }, []);

  return (
    <>
      <ForceReloadModal isOpen={update === "forced"} onReload={onReload} />
      {update === "soft" && !dismissed ? (
        <UpdateBanner onReload={onReload} onDismiss={dismiss} />
      ) : null}
    </>
  );
};
